(function(angular) {
    'use strict';
    
    var directiveName = 'apFindPharmacy';

    angular.module('aprima-core-ui').directive(directiveName, [
        '$q',
        'ApReadonlyFindControl',
        'AprimaCache',
        'PatientRepository',
        'PharmacyRepository',
        'ServerInfoRepository',
        ApFindPharmacy,
    ]);

    function ApFindPharmacy(
        $q,
        ApReadonlyFindControl,
        AprimaCache,
        PatientRepository,
        PharmacyRepository,
        ServerInfoRepository
    ) {
        var vm = null;
        var validationKey = 'pharmacyMatch';
        var idProperty = 'Id';
        var templateUrl = '/core-ui/views/directives/find/apFindPharmacy.html';
        var patientPharmaciesCache = AprimaCache.getOrCreate('PatientDefaultPharmacies', {
            maxAge: 5 * 60 * 1000, // 5 minutes
            deleteOnExpire: 'passive',
            capacity: 20,
        });
        var defaultHeader = 'Patient\'s Pharmacies';
        
        var directiveDefinition = ApReadonlyFindControl.init(
            directiveName,
            PharmacyRepository.getPharmacy,
            PharmacyRepository.searchPharmacies,  // searchPharmaciesIncludeAllMailOrders,
            validationKey,
            templateUrl,
            idProperty,
            validator,
            true,
            onInitCtrl,
            getDefaultList,
            defaultHeader
        );
        directiveDefinition.bindToController.patientId = '<?';
        directiveDefinition.bindToController.autoFocus = '<?';
        
        return directiveDefinition;

        function getDefaultList(ctrl) {
            var patientId = ctrl.patientId;

            if(!patientId) {
                return $q.when([]);
            }

            var cachedPharmacies = patientPharmaciesCache.get(patientId);
            if(cachedPharmacies) {
                return $q.when(cachedPharmacies);
            }

            var promise = PatientRepository.getPharmacies(patientId).then(function(data) {
                var pharmacies = data && (data.plain ? data.plain() : data);

                if (!pharmacies || pharmacies.length < 1) {
                    pharmacies = [{
                        Name: '(No pharmacies listed for this patient.)',
                        PharmacyId: '00000000-0000-0000-0000-000000000000',
                    }];
                }

                if(pharmacies) {
                    patientPharmaciesCache.put(patientId, pharmacies);
                }
                return pharmacies;
            });
            return promise;
        }

        function onInitCtrl(ctrl) {
            vm = ctrl;
            vm.placeholderText = 'Search pharmacies';
            if(ServerInfoRepository.isFeatureSupported('EnhancedPharmacySearch')) {
                vm.placeholderText += ' (+ zip code)';
            }

            vm.getSearchTextFromPharmacy = getSearchTextFromPharmacy;
        }

        function validator(pharmacy) {
            var isValid = !pharmacy ||
                          (pharmacy[idProperty] &&
                          (pharmacy.hasOwnProperty('Name') || pharmacy.hasOwnProperty('Address')));
            return isValid;
        }

        function getSearchTextFromPharmacy(pharmacy) {
            if(pharmacy && pharmacy.Name && pharmacy.Address) {
                return pharmacy.Name + ' - ' + pharmacy.Address.Address1;
            }
            else if(pharmacy && pharmacy.Name) {
                return pharmacy.Name;
            }
            return '';
        }
    }

})(window.angular);
